import classNames from 'classnames'
import Image from 'next/image'
import React, { type FC } from 'react'
import styles from './StoreRatings.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { getImageUrl } from '@/tools/image-service/client'

interface Props {
  isNew: boolean
  ratings: { score: string; icon: string; votes?: string }
}

export const StoreRatings: FC<Props> = ({ isNew, ratings }) => {
  const imageUrl = (url: string) =>
    getImageUrl({
      source: url,
    })

  const { t } = useLocalisation()

  const newStoreIcon = getImageUrl({
    source: 'dh:customer-assets-glovo/feed/tags/cornet.png',
  })

  return (
    <div className={styles.ratings}>
      {isNew ? (
        <>
          <Image
            alt={t('store-wall.new-tag')}
            height={18}
            src={imageUrl(newStoreIcon)}
            width={18}
          />
          <p className={'pintxo-typography-caption-emphasis'}>{t('store-wall.new-tag')}</p>
        </>
      ) : (
        <>
          {ratings && (
            <>
              <Image alt={ratings.score} height={16} src={imageUrl(ratings.icon)} width={16} />
              <p className="pintxo-typography-caption-emphasis">{ratings.score}</p>
              {ratings.votes && (
                <p className={classNames('pintxo-typography-caption', styles.votes)}>
                  {ratings.votes}
                </p>
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}
